import React from 'react';
import OceanScene from '../../Utility/OceanScene/OceanScene';
import { useLoginBrand } from '../../../features/auth/presentation/useLoginBrand';

// Shared side panel for every auth screen (login, register, reset, confirm…).
// It self-resolves pre-auth workspace branding from the `?ws=<uuid>` param via
// useLoginBrand, so ALL auth pages that render this panel brand consistently
// with no per-page wiring. Explicit brandLogo/brandName props still win when a
// caller wants to override (e.g. a page with its own brand source).
const LoginSidePanel = ({ brandLogo, brandName } = {}) => {
  const loginBrand = useLoginBrand();
  // Hold the logo/wordmark render while a `?ws=` brand is still resolving so a
  // branded visitor never sees the default Octopus flash first. An explicit
  // brandLogo/brandName override skips the hold (the caller already knows it).
  const pending = !brandLogo && !brandName && loginBrand.resolving;
  return (
    <div className="basis-0 grow hidden md:flex h-screen">
      <OceanScene
        brandLogo={brandLogo || loginBrand.logoUrl || undefined}
        brandName={brandName || loginBrand.name || undefined}
        pending={pending}
      />
    </div>
  );
};

export default LoginSidePanel;
